import React from 'react';

function ResultDisplay() {
  return (
    <div className="result">
      The news article is 100% legit
    </div>
  );
}

export default ResultDisplay;

